export default {
  changeTrail(state, trails) {
    state.activeTrail = trails;
  },
  changeActiveIndex(state, index) {
    state.activeIndex = index;
  },
  GET_COMPANIES(state, companies) {
    let companyNames = companies.data == null ? [] : companies.data;
    if (companies.meta && companies.meta.hasPreviousPage) {
      companyNames = [...state.companyList.data, ...companies.data];
    }
    state.companyList = companies;
    state.companyList.data = companyNames;
  },

  GET_ORDERS(state, orders) {
    state.orders = orders;
  },

  GET_ORDERS_TOTAL_SALES(state, orders) {
    state.ordersTotalSales = orders;
  },

  GET_USERS_FOR_PAGINATION(state, users) {
    state.userList = users;
  },

  GET_USERS_FOR_INFINTE_SCROLL(state, users) {
    let memberNames = users.data == null ? [] : users.data;
    if (users.meta && users.meta.hasPreviousPage) {
      memberNames = [...state.userList.data, ...users.data];
    }
    state.userList = users;
    state.userList.data = memberNames;
  },
  GET_EVENTS(state, events) {
    let eventNames = events.data == null ? [] : events.data;
    if (events.meta && events.meta.hasPreviousPage) {
      eventNames = [...state.eventsList.data, ...events.data];
    }
    state.eventsList = events;
    state.eventsList.data = eventNames;
  },
  GET_OPTIONS(state, options) {
    let optionNames = options.data == null ? [] : options.data;
    if (options.meta && options.meta.hasPreviousPage) {
      optionNames = [...state.optionsList.data, ...options.data];
    }
    state.optionsList = options;
    state.optionsList.data = optionNames;
  },
  GET_EMAILNOTIF(state, emailNotif) {
    let emailNotifNames = emailNotif.data == null ? [] : emailNotif.data;
    if (emailNotif.meta && emailNotif.meta.hasPreviousPage) {
      emailNotifNames = [
        ...state.emailNotificationsLists.data,
        ...emailNotif.data
      ];
    }
    state.emailNotificationsLists = emailNotif;
    state.emailNotificationsLists.data = emailNotifNames;
  },
  GET_USER_SCHEME(state, scheme) {
    state.schemeList = scheme;
  },
  GET_GROUPS(state, groups) {
    let groupNames = groups.data == null ? [] : groups.data;
    if (groups.meta && groups.meta.hasPreviousPage) {
      groupNames = [...state.groupList.data, ...groups.data];
    }
    state.groupList = groups;
    state.groupList.data = groupNames;
  },
  SET_ORDER_STATUS(state, payload) {
    state.orders.status = payload;
  },
  SET_REPORT_FILTER(state, payload) {
    state.filters = payload;
  },
  SET_REPORT_HISTORY(state, status) {
    state.reportHistory = status;
  },
  SET_STRIPE_CHECKOUT(state, payload) {
    state.stripeCheckout = payload;
  }
};
